import '../styleDialog.css';
import CustomSnackbar from '../../Components/CustomSnackbar';
import React from 'react';
import CableHighwayDialog from './DialogDescriptionType/CableHighwayDialog';
import CableCantonDialog from './DialogDescriptionType/CableCantonDialog';
import WellCantonDialog from './DialogDescriptionType/WellCantonDialog';
import WellHighwayDialog from './DialogDescriptionType/WellHighwayDialog';
import PillarHighwayDialog from './DialogDescriptionType/PillarHighwayDialog';
import PillarCantonDialog from './DialogDescriptionType/PillarCantonDialog';
import CouplingCantonDialog from './DialogDescriptionType/CouplingCantonDialog'
import CouplingHighwayDialog from './DialogDescriptionType/CouplingHighwayDialog';
import FobHighwayDialog from './DialogDescriptionType/FobHighwayDialog';
import FobCantonDialog from './DialogDescriptionType/FobCantonDialog';
import PonBoxCantonDialog from './DialogDescriptionType/PonBoxCantonDialog';
import { CONST_CANTON, CONST_HIGHWAY, CONST_CANTON_MANHOLE, CONST_HIGHWAY_MANHOLE,
  CONST_CANTON_PILLAR, CONST_HIGHWAY_PILLAR, CONST_HIGHWAY_COUPLING, CONST_CANTON_COUPLING,
  CONST_HIGHWAY_FOB, CONST_CANTON_FOB,
  CONST_CANTON_PON_BOX,
  CONST_CANTON_PASSIVE_NODE} from '../../Constants/ConstantsOptics';
import DialogPassiveNodeDescroption from '../DialogNode/DialogPassiveNodeDescroption';

const DialogDescriptionComponent = ({ open, onClose, setOpenModal, content, markerType,isLineDrawing, manholeMarker,
      pillarMarker, couplingMarker, fobMarker, ponBoxMarker, role, user, changeLinkEditing, linkEditing, highwayRefresh, cantonRefresh,
      groupedCoordinatesWithColorTypeAndWidth, wellData, fobLocationData, couplingLocationData, ponBoxLocationData, pillarData, setIsComponentСhangeCoor,
      cantonFobRefresh, cantonCouplingRefresh, cantonWellRefresh, cantonPillarRefresh, cantonPonBoxRefresh, cantonCablaRefresh, setIsComponentСhangeCoorPillar,
      setIsComponentСhangeCoorCoupling, setIsComponentСhangeCoorFob, setIsComponentСhangeCoorPonBox, changeLinkEditingMarker, linkEditingProblem,
      cantonCablaByIdRefresh, passiveNodeMarker, cantonPassiveNodeRefresh, setIsComponentChangeCoorPassiveNode, highwayWellRefresh,
      highwayPillarRefresh, highwayCouplingRefresh, highwayFobRefresh}) => {
 
const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

 const rawTerritory  = localStorage.getItem('territory'); 
 const territoryList = rawTerritory.split(',').map(c => c.trim());

const copyToClipboard = (text, type) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  textarea.focus(); 
  try {
    const successful = document.execCommand("copy");
    if (successful) {
      showSnackbar('Скопировано: ' + type + ': ' + text, 'snackbarOk');
    } else {
      showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
    }
  } catch (err) {
    showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
  }
  document.body.removeChild(textarea);
};

  if (markerType === CONST_HIGHWAY && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker) && !linkEditing && !linkEditingProblem) {
    return (
      <CableHighwayDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        changeLinkEditing={changeLinkEditing}
        highwayRefresh={highwayRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        changeLinkEditingMarker={changeLinkEditingMarker}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
        
      />
   );
  }
  else if (markerType === CONST_CANTON && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker) && !linkEditing && !linkEditingProblem) {
    return (
      <CableCantonDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        changeLinkEditing={changeLinkEditing}
        cantonRefresh={cantonCablaRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        changeLinkEditingMarker={changeLinkEditingMarker}
        cantonCablaByIdRefresh={cantonCablaByIdRefresh}
        territoryList={territoryList}
      />
    );
  }
  else if (markerType === CONST_CANTON_MANHOLE && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <WellCantonDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        cantonRefresh={cantonWellRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoor={setIsComponentСhangeCoor}
      />  
    );
  }
  else if (markerType === CONST_HIGHWAY_MANHOLE && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <WellHighwayDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        highwayRefresh={highwayWellRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoor={setIsComponentСhangeCoor}
      />
    );
  }
  else if (markerType === CONST_HIGHWAY_PILLAR && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
        <PillarHighwayDialog
          open={open}
          onClose={onClose}
          content={content}
          snackbarOpen={snackbarOpen}
          snackbarMessage={snackbarMessage}
          snackbarClass={snackbarClass}
          handleCloseSnackbar={handleCloseSnackbar}
          copyToClipboard={copyToClipboard}
          role={role}
          user={user}
          highwayRefresh={highwayPillarRefresh}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
          setIsComponentСhangeCoor={setIsComponentСhangeCoorPillar}
        />
    );
  }
  else if (markerType === CONST_CANTON_PILLAR && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
        <PillarCantonDialog
          open={open}
          onClose={onClose}
          content={content}
          snackbarOpen={snackbarOpen}
          snackbarMessage={snackbarMessage}
          snackbarClass={snackbarClass}
          handleCloseSnackbar={handleCloseSnackbar}
          copyToClipboard={copyToClipboard}
          role={role}
          user={user}
          cantonRefresh={cantonPillarRefresh}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
          setIsComponentСhangeCoor={setIsComponentСhangeCoorPillar}
        />
    );
  }
  else if (markerType === CONST_HIGHWAY_COUPLING && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <CouplingHighwayDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        highwayRefresh={highwayCouplingRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
      />
    );
  }
  else if (markerType === CONST_CANTON_COUPLING && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <CouplingCantonDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        cantonCouplingRefresh={cantonCouplingRefresh}
        setIsComponentСhangeCoorCoupling={setIsComponentСhangeCoorCoupling}
        territoryList={territoryList}
      />
    );
  }
  else if (markerType === CONST_HIGHWAY_FOB && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <FobHighwayDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        highwayRefresh={highwayFobRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
        
      />
    );
  }
  else if (markerType === CONST_CANTON_FOB && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <FobCantonDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        cantonFobRefresh={cantonFobRefresh}
        setIsComponentСhangeCoorFob={setIsComponentСhangeCoorFob}
        territoryList={territoryList}
      />
    );
  }
  else if (markerType === CONST_CANTON_PON_BOX && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
    return (
      <PonBoxCantonDialog
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        role={role}
        user={user}
        cantonRefresh={cantonPonBoxRefresh}
        groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
        wellData={wellData}
        fobLocationData={fobLocationData}
        couplingLocationData={couplingLocationData}
        ponBoxLocationData={ponBoxLocationData}
        pillarData={pillarData}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
        territoryList={territoryList}
      />
    );
  }
 else if (markerType === CONST_CANTON_PASSIVE_NODE && !(isLineDrawing || manholeMarker || pillarMarker || couplingMarker|| fobMarker || ponBoxMarker || passiveNodeMarker)) {
     return (
     
    <DialogPassiveNodeDescroption
      openModalNode={open}
      handleCloseModal={onClose}
      content={content}
      user={user}
      cantonRefresh={cantonRefresh}
      role={role}
      flag={CONST_CANTON}
      cantonPassiveNodeRefresh={cantonPassiveNodeRefresh}
      cantonPonBoxRefresh={cantonPonBoxRefresh}
      cantonFobRefresh={cantonFobRefresh}
      setIsComponentChangeCoorPassiveNode={setIsComponentChangeCoorPassiveNode}
    />
   );
  }
  else {
    return null; 
  }
  }
 
export default DialogDescriptionComponent;